/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button as MuiButton,
  TextField as MuiTextField,
  Select as MuiSelect, MenuItem,
  Autocomplete as MuiAutocomplete,
  Stack,
  Radio as MuiRadio,
} from '@mui/material';
import classes from './Form.module.css';

export function Button({ variant, onClick, children }) {
  return (
    <MuiButton
      variant={variant}
      style={{ textTransform: 'none' }}
      sx={{
        height: '48PX',
        borderRadius: 0,
        backgroundColor: '#645AFF',
        '&:hover': {
          backgroundColor: '#5950DF',
        },
      }}
      onClick={onClick}
    >
      {children}
    </MuiButton>
  );
}
Button.propTypes = {
  variant: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.string,
};
Button.defaultProps = {
  variant: '',
  onClick: () => undefined,
  children: '',
};

export const Input = React.forwardRef(({
  name, label, placeholder, ...rest
}, ref) => (
  <Stack alignItems="flex-start">
    <label className={classes.label} htmlFor={name}>{label}</label>
    <input ref={ref} autoComplete="off" height="36" className={classes.input} name={name} placeholder={placeholder} {...rest} />
  </Stack>
));
Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};
Input.defaultProps = {
  placeholder: '',
  label: '',
};

export function TextField({
  variant, children, inputRef, onChange, placeholder,
}) {
  return (
    <MuiTextField
      sx={{
        width: '100%',
        '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused': {
          border: '1px solid #645AFF',
          boxShadow: '0 0 5PX #645AFF',
        },
        '& .MuiInputBase-root.MuiOutlinedInput-root': {
          borderRadius: 0,
          height: '48PX',
          border: '1px solid #C9CCCF',
          backgroundColor: 'white',
        },
        '& .MuiInputBase-root.MuiOutlinedInput-root:hover': {
          borderColor: '#645AFF',
        },
        '&': {
          '&& fieldset': {
            border: 'none',
          },
        },
      }}
      variant={variant}
      onChange={onChange}
      inputRef={inputRef}
      placeholder={placeholder}
      inputProps={{
        style: {
          color: '#202223',
          height: '46px',
          fontSize: '14px',
          padding: '0 14px',
          boxSizing: 'border-box',
          WebkitBoxShadow: '0 0 0 1000px white inset',
        },
      }}
    >
      {children}
    </MuiTextField>
  );
}
TextField.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.string,
  onChange: PropTypes.func,
  inputRef: PropTypes.element,
  placeholder: PropTypes.string,
};
TextField.defaultProps = {
  variant: '',
  children: '',
  onChange: () => undefined,
  inputRef: '',
  placeholder: '',
};

export function Select({
  field, onChange, options, style,
}) {
  const {
    onBlur, name, ref, value,
  } = field;
  return (
    <MuiSelect
      // eslint-disable-next-line react/jsx-props-no-spreading
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      name={name}
      inputRef={ref}
      style={style}
      displayEmpty
      sx={{
        width: '100%',
        height: '36PX',
        '&:hover': {
          '&& fieldset': {
            border: '1px solid #645AFF',
          },
        },
        '&': {
          '&& fieldset': {
            borderRadius: 0,
          },
        },
        '& .MuiOutlinedInput-input': {
          textAlign: 'left',
          fontSize: 14,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: '1px solid #645AFF',
          boxShadow: '0 0 5PX #645AFF',
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            '&': {
              borderRadius: 0,
            },
            '& .MuiMenuItem-root': {
              fontSize: 14,
            },
            '& .MuiMenuItem-root.Mui-selected': {
              backgroundColor: '#C8C5FF',
            },
            '& .MuiMenuItem-root:hover': {
              backgroundColor: '#F7F7FC',
            },
          },
        },
      }}
    >
      {
        // eslint-disable-next-line max-len, react/no-array-index-key
        options.map((option, index) => <MenuItem key={`${option.value}-${index}`} value={option.value === undefined ? index : option.value}>{option.name}</MenuItem>)
      }
    </MuiSelect>
  );
}
Select.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  field: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};
Select.defaultProps = {
  style: {},
};

export function Autocomplete({ field, options }) {
  const {
    onChange, ref, ...rest
  } = field;
  return (
    <MuiAutocomplete
      name="autocomplete"
      sx={{
        width: '100%',
        height: 36,
        '& .MuiInputBase-input.MuiOutlinedInput-input': {
          fontSize: '14PX',
          paddingLeft: '14PX',
        },
        '& .MuiFormControl-root.MuiTextField-root': {
          height: 36,
        },
        '& .MuiInputBase-root.MuiOutlinedInput-root': {
          padding: 0,
        },
        '&': {
          '&& fieldset': {
            border: '1px solid #BABFC3',
            borderRadius: 0,
          },
        },
        '&:hover': {
          '&& fieldset': {
            borderColor: '#645AFF',
          },
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: '1px solid #645AFF',
          boxShadow: '0 0 5PX #645AFF',
        },
      }}
      // react-hook-form props
      {...rest}
      // inputRef={ref}
      options={options}
      renderInput={(params) => <TextField inputRef={ref} {...params} />}
      onChange={(_, data) => onChange(data)}
    />
  );
}
Autocomplete.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  field: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.array.isRequired,
};

export function Radio(props) {
  return (
    <MuiRadio
      {...props}
      sx={{
        '&.MuiButtonBase-root.MuiRadio-root.Mui-checked': {
          color: props.checkedcolor || '#645AFF',
        },
      }}
    />
  );
}
